import {
  QrTemplate,
  QrTemplateBusinessInfo,
  QrMode,
  PartialColors,
  SlotOffset,
  mergeColors,
  resolveSlotOffsets,
  resolveSlotValues,
} from './types';

export async function loadQrImageFromCanvas(canvas: HTMLCanvasElement): Promise<HTMLImageElement> {
  const dataUrl = canvas.toDataURL('image/png');
  return loadImageFromDataUrl(dataUrl);
}

export function loadImageFromDataUrl(dataUrl: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = (e) => reject(e);
    img.src = dataUrl;
  });
}

export interface RenderOverrides {
  colors?: PartialColors;
  slotTextOverrides?: Record<string, string>;
  slotOffsetOverrides?: Record<string, SlotOffset>;
}

export function renderTemplateToCanvas(
  template: QrTemplate,
  qrImage: HTMLImageElement,
  business: QrTemplateBusinessInfo,
  mode: QrMode,
  overrides?: RenderOverrides,
): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = template.canvasWidth;
  canvas.height = template.canvasHeight;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Canvas 2D context not available');
  }
  const colors = mergeColors(template.defaultColors, overrides?.colors);
  const slotValues = resolveSlotValues(template.slots, mode, overrides?.slotTextOverrides);
  const slotOffsets = resolveSlotOffsets(template.slots, overrides?.slotOffsetOverrides);
  template.render({ ctx, canvas, qrImage, business, mode, colors, slotValues, slotOffsets });
  return canvas;
}

export function canvasToPngDataUrl(canvas: HTMLCanvasElement): string {
  return canvas.toDataURL('image/png');
}

export function downloadCanvasAsPng(canvas: HTMLCanvasElement, fileName: string): void {
  const dataUrl = canvasToPngDataUrl(canvas);
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function sanitizeFileName(input: string): string {
  return (input || 'qr-code')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'qr-code';
}
